module.exports = __webpack_public_path__ + "img/warning.015fc846.png";